import React, { memo, Suspense, useCallback } from 'react';
import noop from 'lodash/noop';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import EditorOptionsList from '@/modules/corporate/modules/questions/fields/single-select/EditorOptionsList';
import QuestionEntity from '@/modules/question/entity/Question';
import { UpdateQuestionEntity } from '@/types/schema';

import { SelectEditorOptionsListProps } from './types';

function SelectEditorOptionsList(props: SelectEditorOptionsListProps) {
  const { question, onChange: onChangeProp, isMultiSelect, viewMode } = props;

  const onChange = useCallback(
    (updatedQuestion: UpdateQuestionEntity) => {
      onChangeProp({ options: { set: updatedQuestion.options?.set || [] } });
    },
    [onChangeProp],
  );

  return (
    <Stack className={cn('pt-8')} direction="col" gapY={16}>
      <Suspense fallback={null}>
        <EditorOptionsList
          isMultiSelect={isMultiSelect}
          question={question}
          questionLabel={QuestionEntity.questionTextLabel(question.questionText)}
          setNudgeState={noop}
          variant="survey"
          // we want to enable editing after publishing as well. but edit is only allowed in 'create' mode
          viewMode={'create'}
          onChange={onChange}
        />
      </Suspense>
    </Stack>
  );
}

export default memo(SelectEditorOptionsList);
